import { useState } from 'react';
import './Transfer.css';
import { removeFromCardBalance, userStatistics } from '../../utils/api';
import { useUI } from '../../hooks/useUI';

const Transfer = (props) => {
    const [isValid, setIsValid] = useState(true);
    const [transferAmount, setTransferAmount] = useState('');

    const { userData, setUserData, closeModal } = useUI();

    async function validateTransferAmount() {
        try {
            let testTransferAmount = Number(transferAmount);
            if (transferAmount <= 0 || testTransferAmount != transferAmount) return setIsValid(false);

            await removeFromCardBalance(window.Telegram.WebApp.initData, testTransferAmount);

            const response = await userStatistics(window.Telegram.WebApp.initData);
            setUserData(response.result);
            closeModal('modalWindow');
        } catch (err) {
            console.log(err);
            setIsValid(false);
        }
    }

    // Проверка, заполнен ли инпут
    const isInputFilled = () => {
        return transferAmount.trim() !== '';
    };

    // Обработчик нажатия Enter
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && isInputFilled() && isValid) {
            validateTransferAmount();
            // Снимаем фокус с инпута
            document.activeElement.blur();
        }
    };

    return (
        <div className='transfer'>
            <input
                type="text"
                placeholder="Enter transfer amount"
                value={transferAmount}
                onChange={(e) => {
                    setTransferAmount(e.target.value);
                    setIsValid(true);
                }}
                onKeyDown={handleKeyDown} // Добавляем обработчик Enter
                id="input_dep"
                className={`transfer__input ${isValid ? '' : 'transfer__input--error'}`}
            />
            <button
                className="transfer__btn"
                onClick={validateTransferAmount}
            >
                Submit
            </button>
        </div>
    )
}

export default Transfer;